import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "@rubbl-core";
import { RubblFormsModule } from "@rubbl-forms";
import { RubblSharedModule } from "@rubbl-shared";
import { TablesModule } from "@rubbl-tables";
import { AccountModule } from "@rubbl-account";
import { MarketingModule } from "@rubbl-marketing";
import { GettingStartedCardComponent } from "./getting-started-card/getting-started-card.component";
import { ActivityModule } from "@rubbl-activity";

@NgModule({
  declarations: [GettingStartedCardComponent],
  imports: [CommonModule, TablesModule, CoreModule, RubblSharedModule, RubblFormsModule, AccountModule, MarketingModule, ActivityModule],
  exports: [TablesModule, CoreModule, RubblSharedModule, RubblFormsModule, AccountModule, MarketingModule, GettingStartedCardComponent, ActivityModule],
})
export class ManageSharedModule {}
